import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Cascader, Form, message, Select, Switch } from 'antd'
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions, STitle } from 'shj-components'
import { useSetState } from 'ahooks'
import { config } from './config.tsx'
import ArriveModal from './components/ArriveModal'
import styles from './index.module.less'
import { getGeneralPage, getGoodsManagementGoodsBaseInfo } from '@/services/product.ts'
import { apiData2Table } from '@/utils/data.ts'
import {
  getGoodsSaleCategoryTreeList,
  goodsManagementBatchChangeState,
  goodsManagementGetPrdArgManageListByGoodsId,
  goodsManagementGoodsSkuPage,
  goodsManagementGoodsSkuSave,
  goodsManagementSaveSaleCat,
} from '@/services/goods.ts'
import { cloneDeep, debounce, isEmpty } from 'lodash-es'
import { getParentId } from '@/utils/common.ts'

export default function PriceManage() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const listRef = useRef()

  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const saleCatId = searchParams.get('saleCatId')
  const [state, setState] = useSetState({
    treeData: [], // 左侧树形结构数据
    brandList: [], // 品牌
    categoryCode: null, // 当前选中品类code
    categoryTree: [],
    budgetList: [],
  })
  const [openArriveModal, setOpenArriveModal] = useState(false)
  const [isMultipleModal, setIsMultipleModal] = useState(false)
  const [idList, setIdList] = useState([])
  const [record, setRecord] = useState({})
  const [search, setSearch] = useState([])
  const baseColumns = [
    {
      title: 'SKU编码',
      key: 'skuCode',
      dataIndex: 'skuCode',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '是否上架',
      dataIndex: 'onSelf',
      render: 'switchRender',
      width: 100,
    },
    {
      title: '上架门店',
      dataIndex: 'channelJson',
      render: 'jsonRender',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '关联楼盘',
      dataIndex: 'channelJson',
      render: 'buildingRender',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '关联户型',
      dataIndex: 'channelJson',
      render: 'houseTypeRender',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '成交王店铺',
      dataIndex: 'saleCatName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'C端小程序',
      dataIndex: 'memberCatName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 120,
      render: 'actionRender',
      fixed: 'right',
    },
  ]
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (id) getInfo()
  }, [id])

  useEffect(() => {
    if (saleCatId && state.categoryTree.length) {
      const pathId = getParentId(state.categoryTree, saleCatId)
      form.setFieldsValue({ sellCategory: pathId?.reverse() })
    }
  }, [saleCatId, state.categoryTree])

  const getInfo = () => {
    getGoodsManagementGoodsBaseInfo({ params: { goodsId: id } }).then(res => {
      const search = res?.reduce((res, item) => {
        if (item.argType === 'CHOOSE') {
          const arr = [
            {
              label: item.argName,
              name: item.argCode,
              dataIndex: item.argCode,
              itemType: 'select',
              data: item.argValueJson?.list,
              labelKey: 'name',
              key: 'id',
              events: ['onChange:onChangeCode'],
            },
            {
              label: item.argName,
              name: item.argCode + 'Name',
              hidden: true,
            },
          ]
          return res.concat(arr)
        }
      }, [])
      console.log(search)
      setSearch(search)
    })
  }

  //   右侧数据查询
  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      if (!isEmpty(query)) {
        const keys = Object.keys(query)
        query.queryList = []
        keys.forEach(key => {
          if (query[key]) {
            query.queryList.push({ code: key, dtlList: [{ id: query[key] }] })
            delete query[key]
          }
        })
      }
      console.log(query)
      goodsManagementGoodsSkuPage({
        params: { pageId: current, pageSize },
        data: { ...query, goodsId: id },
      })
        .then(res => {
          const skuArgs = res.list?.[0]?.skuJson?.skuArgs || []
          const columns_ = cloneDeep(baseColumns)
          const columnArr =
            skuArgs?.map((item, index) => ({
              title: item.argName,
              dataIndex: item.argType === 'CHOOSE' ? ['skuJson', 'skuArgs', index, 'argValName'] : ['skuJson', 'skuArgs', index, 'argVal'],
              width: 200,
              ellipsis: true,
              // render: 'argRender',
            })) || []
          columns_.splice(1, 0, ...columnArr)
          setColumns(columns_)
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  //   右侧下拉选项加载
  const getOptions = async () => {
    const categoryTree = await getGoodsSaleCategoryTreeList({ enabled: true })
    const budgetList = await goodsManagementGetPrdArgManageListByGoodsId({ goodsId: id })
    setState({ categoryTree, budgetList })
    Promise.resolve({ categoryTree, budgetList })
  }

  // 右侧表格事件：
  const onAdd = () => {
    navigate('/config/commodityManage/commodityEdit')
  }

  const onEdit = (record = {}) => {
    setIsMultipleModal(false)
    setOpenArriveModal(true)
    setIdList([record.id])
    setRecord(record)
  }

  const onMultipleEdit = ({ selectedRowKeys }) => {
    setIsMultipleModal(true)
    setOpenArriveModal(true)
    setIdList(selectedRowKeys)
  }

  const handleCloseArriveModal = () => {
    setOpenArriveModal(false)
    setRecord({})
  }

  const onChangeState = record => {
    if (record.onSelf) {
      SMessage.confirm({
        title: '关闭开关将下架该SKU，是否继续？',
        content: null,
        okText: '继续',
        cancelText: '取消',
        onOk: () => {
         return goodsManagementGoodsSkuSave({ idList: [record.id], onSelf: false }).then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
          })
        },
      })
    } else onEdit(record)
  }

  const onChangeCode = (...e) => {
    console.log(e)
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd, onEdit, onMultipleEdit, onChangeCode },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checked={v}
            checkedChildren="上架"
            unCheckedChildren="下架"
            onClick={() => onChangeState(record)}
          />
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {record.onSelf && <SActionBtn onClick={() => onEdit(record)}>编辑上架门店</SActionBtn>}
          </STableActions>
        )
      },
      jsonRender(v) {
        const { shopJsonList } = v !== undefined ? v : {}
        return shopJsonList?.map(item => item.name)?.join(',')
      },
      buildingRender(v) {
        const { buildingJsonList } = v !== undefined ? v : {}
        return buildingJsonList?.map(item => item.name)?.join(',')
      },
      houseTypeRender(v) {
        const { houseTypeJsonList } = v !== undefined ? v : {}
        return houseTypeJsonList?.map(item => item.name)?.join(',')
      },
      argRender(v, o, i) {
        const { skuArgs } = v || {}
        return skuArgs?.[i - 2]?.argValName || skuArgs?.[i - 2]?.argVal
      },
    },
  }

  return (
    <SBack
      title="商品上下架"
      // titleStyle={{ padding: 15, background: '#fff' }}
      level={2}
      goPath={() => navigate('/config/commodityManage')}
    >
      <div className={styles.settlementQuotaConfig}>
        {/* 右侧数据表格 */}
        <div className={styles.rightTable}>
          <SLowcodeList
            ref={listRef}
            searchMode="group"
            config={{
              search,
              columns,
              batchActions: [
                {
                  label: '批量设置',
                  type: 'primary',
                  // auth: 'priceButton4',
                  events: ['onClick:onMultipleEdit'],
                },
              ],
            }}
            {...extensions}
          />
        </div>
        <ArriveModal
          fn={listRef.current?.reload}
          record={record}
          open={openArriveModal}
          idList={idList}
          onClose={handleCloseArriveModal}
          isMultiple={isMultipleModal}
        />
      </div>
    </SBack>
  )
}
